import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface HasChanges {
  ngbModal?: NgbModal;
  readonly hasChanges: boolean;
}

export function hasChangesOnBeforeUnloadListener(this: HasChanges, $event: BeforeUnloadEvent) {
  if (this.hasChanges || (this.ngbModal && this.ngbModal.hasOpenModals())) {
    $event.preventDefault();
    $event.returnValue = 'There are unsaved changes. Do you want to exit without saving?';
  }
}
